import { useUserRole, InstitutionRole } from "@/hooks/useUserRole";

interface RoleGuardProps {
  children: React.ReactNode;
  requiredRoles: InstitutionRole[];
  fallback?: React.ReactNode;
}

export const RoleGuard = ({ children, requiredRoles, fallback = null }: RoleGuardProps) => {
  const { hasAnyRole, isLoading } = useUserRole();

  if (isLoading) {
    return null;
  }

  // NOTE: This is UX only. Authorization enforced by RLS policies in database
  if (!hasAnyRole(requiredRoles)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
